export const rollcallLeaveDetails = [
    {
        "s_no": 1,
        "Badge": 17,
        "Employee": "arudra",
        "Type": "Casual",
        "NoOfLvs": 1,
        "StartDate": "1/5/2024 12:00:00 AM",
        "EndDate": "1/5/2024 12:00:00 AM",
        "Reason": "BROTHER MALA"
    },
    {
        "s_no": 2,
        "Badge": 15,
        "Employee": "Pameela",
        "Type": "Personal",
        "NoOfLvs": 1,
        "StartDate": "1/10/2024 12:00:00 AM",
        "EndDate": "1/10/2024 12:00:00 AM",
        "Reason": "BROTHERS MALA FUNCTION"
    },
    {
        "s_no": 3,
        "Badge": 7,
        "Employee": "GOPI",
        "Type": "Personal",
        "NoOfLvs": 1,
        "StartDate": "1/9/2024 12:00:00 AM",
        "EndDate": "1/9/2024 12:00:00 AM",
        "Reason": "AADHAR"
    },
    {
        "s_no": 4,
        "Badge": 16,
        "Employee": "Jyoti",
        "Type": "Personal",
        "NoOfLvs": 3,
        "StartDate": "1/10/2024 12:00:00 AM",
        "EndDate": "1/12/2024 12:00:00 AM",
        "Reason": "DINAM"
    },
    {
        "s_no": 5,
        "Badge": 14,
        "Employee": "Gousiya",
        "Type": "Casual",
        "NoOfLvs": 1,
        "StartDate": "1/24/2024 12:00:00 AM",
        "EndDate": "1/24/2024 12:00:00 AM",
        "Reason": "PERIODS"
    },
    {
        "s_no": 6,
        "Badge": 22,
        "Employee": "YUSUF",
        "Type": "Personal",
        "NoOfLvs": 2,
        "StartDate": "1/23/2024 12:00:00 AM",
        "EndDate": "1/24/2024 12:00:00 AM",
        "Reason": "FEVER"
    },
    {
        "s_no": 7,
        "Badge": 4,
        "Employee": "Babji",
        "Type": "Personal",
        "NoOfLvs": 1,
        "StartDate": "1/27/2024 12:00:00 AM",
        "EndDate": "1/27/2024 12:00:00 AM",
        "Reason": "DEADTH"
    },
    {
        "s_no": 8,
        "Badge": 13,
        "Employee": "Anuradha",
        "Type": "Personal",
        "NoOfLvs": 1,
        "StartDate": "1/25/2024 12:00:00 AM",
        "EndDate": "1/25/2024 12:00:00 AM",
        "Reason": "SRIMANTHAM"
    }
]
